import { render, staticRenderFns } from "./empresas-grupo.vue?vue&type=template&id=c8f6d1c6&scoped=true"
import script from "./empresas-grupo.vue?vue&type=script&lang=js"
export * from "./empresas-grupo.vue?vue&type=script&lang=js"
import style0 from "./empresas-grupo.vue?vue&type=style&index=0&id=c8f6d1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f6d1c6",
  null
  
)

export default component.exports